module.exports = __webpack_public_path__ + "media/images/tab_arrow1-8247e6dc831a7a010fe3c0e2d7071600.png";